// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"215":"a4de47ed","265":"9e886e6d","297":"3b65f507","643":"77b1a2ed","787":"f022b0b4","959":"f763083e"}[chunkId] + ".chunk.js";
};